
import PleaseLogin from './PleaseLogin';
import PleaseBuy from './PleaseBuy';

import styles from './FirstPage.module.css';

function Nutzungsinfos({ isEligable, isLoggedIn, availableUses, usageCount }) {
  // DEBUG LOG
  // console.log("Nutzungsinfos, isEligable:", isEligable, "isLoggedIn:", isLoggedIn, "availableUses:", availableUses, "usageCount:", usageCount)
  return <div>
    <h3 className={styles.FirstPage_h}>Nutzungsinformationen</h3>
    {isEligable
      ?
      <p className={styles.FirstPage_p}>
        Du hast noch {availableUses - usageCount} verbleibende Benutzungen. <br />
        Jedes mal wenn du etwas änderst und dann die Ergebnisse abrufst wird eine Nutzung abgebucht.
      </p>
      :
      isLoggedIn ?
      <PleaseBuy usageCount={usageCount} />
      :
      <div>
        <p className={styles.FirstPage_p}>Damit Du den Generator vollständig nutzen kannst, musst du zuerst:</p>
        <ol style={{ textAlign: 'left', marginLeft: 'calc(2rem + 5%)', marginRight: 'calc(2rem + 5%)' }}>
          <li style={{ color: 'white' }}>
            <a href='/kontodaten/checkout/?level=2' style={{ color: '#B9A394', textDecoration: 'underline' }}>Nutzerkonto erstellen</a> oder <a href='/login' style={{ color: '#B9A394', textDecoration: 'underline' }}>Einloggen</a>
          </li>
          <li style={{ color: 'white' }}>
            Kauf abschliessen: Gehe dazu in <a href='/produkt/datenschutzgenerator' style={{ color: '#B9A394', textDecoration: 'underline' }}>den Shop</a> und schliesse den Kauf dort ab.
          </li>
          <li style={{ color: 'white' }}>
            Kehre zum Datenschutzgenerator zurück und erstelle in wenigen Schritten deine individuelle Datenschutzerklärung!
          </li>
        </ol>
      </div>
    }
    <p className={styles.FirstPage_p}>
      <b style={{ textDecoration: 'underline' }}>Wichtiger Hinweis:</b> Wenn Du einen Account erstellst, um den Datenschutzgenerator zu nutzen, dann kann <b>pro Account nur</b> für <b>eine Website</b> eine Datenschutzerklärung erstellt werden.
      Weitere Informationen zur Nutzung findest du <a href='/produkt/datenschutzgenerator' style={{ color: '#B9A394', textDecoration: 'underline' }}>hier</a>.
    </p>
  </div>
}

export default Nutzungsinfos;